import React from "react";

import PoMangerMain from "./Main";
import { PoContextProvider } from "./poContext";

export default function PoManger() {
  return (
    <PoContextProvider>
      <PoMangerMain />
    </PoContextProvider>
  );
}
